export default __webpack_public_path__ + "static/media/ramjas.c1ccadae.png";